import { X } from 'lucide-react'
import Button from '../ui/Button'
import FormError from '../ui/FormError'

interface ReasonModalProps {
  title: string
  body: string
  reasonLabel: string
  reasonPlaceholder: string
  confirmLabel: string
  closeLabel: string
  loading: boolean
  reason: string
  errors: string[]
  onReasonChange: (value: string) => void
  onClose: () => void
  onConfirm: () => void
}

export default function ReasonModal({
  title,
  body,
  reasonLabel,
  reasonPlaceholder,
  confirmLabel,
  closeLabel,
  loading,
  reason,
  errors,
  onReasonChange,
  onClose,
  onConfirm,
}: ReasonModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 px-4">
      <div className="w-full max-w-lg rounded-[1.75rem] bg-white p-6 shadow-2xl">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold text-slate-950">{title}</h2>
            <p className="mt-3 text-sm leading-7 text-slate-600">{body}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition hover:bg-slate-200"
            aria-label={closeLabel}
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-6">
          <FormError errors={errors} />
          <label htmlFor="admin-reason" className="mb-2 mt-4 block text-sm font-semibold text-slate-700">
            {reasonLabel}
          </label>
          <textarea
            id="admin-reason"
            value={reason}
            onChange={(event) => onReasonChange(event.target.value)}
            rows={4}
            placeholder={reasonPlaceholder}
            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 transition focus:border-primary-500 focus:outline-none focus:ring-4 focus:ring-primary-100"
          />
        </div>

        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <Button type="button" variant="secondary" onClick={onClose}>
            {closeLabel}
          </Button>
          <Button type="button" loading={loading} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
